export default __webpack_public_path__ + "static/media/approved-white.1a6644ce.svg";